import { render, staticRenderFns } from "./UserBalanceBalances.vue?vue&type=template&id=e1438108&scoped=true&"
import script from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
import style0 from "./UserBalanceBalances.vue?vue&type=style&index=0&id=e1438108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1438108",
  null
  
)

export default component.exports